<template>
<b-container class="">
<b-jumbotron header="ASM80 Tools Suite" lead="Useful tools for HEX, BIN, ASM processing" >
  <p>Select desired tool from the menu above</p>
</b-jumbotron>
</b-container>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      text: 'Ajho'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
